import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover } from './Popover';

function InformationBox({
  text,
  helpText,
  children,
}: Readonly<{
  text: string;
  helpText?: string;
  children?: React.ReactNode;
}>) {
  return (
    <div className="inline-flex flex-wrap items-center justify-between gap-3 rounded border border-gravel bg-white p-4">
      <div>
        {text}
        {helpText && (
          <Popover content={helpText} positions={['top']}>
            <FontAwesomeIcon
              icon={faQuestionCircle}
              className="ml-0.5 cursor-pointer px-1.5 text-grace"
            />
          </Popover>
        )}
      </div>
      {children}
    </div>
  );
}

export default InformationBox;
